/**
 * A money amount an admin typed, as dollars rounded to cents; null unless it's
 * a real number above zero. The server flips the sign on payouts, so a
 * negative "payout" would credit the account: refuse it here.
 */
export function positiveAmount(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : Number(String(value).trim());
  if (!Number.isFinite(n)) return null;
  const cents = Math.round(n * 100) / 100;
  return cents > 0 ? cents : null;
}

/** What to tell the admin when positiveAmount() refuses. */
export const AMOUNT_ABOVE_ZERO = 'Enter an amount above $0.';

/**
 * A manual balance adjustment an admin typed, as dollars rounded to cents; null
 * unless it's a real number other than zero. Negative amounts are deductions.
 */
export function nonZeroAmount(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : Number(String(value).trim());
  if (!Number.isFinite(n)) return null;
  const cents = Math.round(n * 100) / 100;
  return cents !== 0 ? cents : null;
}

/** What to tell the admin when nonZeroAmount() refuses. */
export const AMOUNT_NOT_ZERO = 'Enter an amount other than $0.';
